import { useLocation, useHistory } from 'react-router-dom';
import ResetBtn from './ResetBtn';
import css from './SearchPage.module.css';
import { useConfiguration } from '../../context/configurationContext';

const ModalFilters = ({ filters, context }) => {
  const location = useLocation();
  const history = useHistory();

  const config = useConfiguration().listing.listingFields;

  const removeFilter = key => {
    const searchParams = new URLSearchParams(location.search);
    if (key === 'pub_categoryLevel1') searchParams.delete('pub_categoryLevel2');
    if (key === 'pub_engine') {
      searchParams.delete('pub_enginecapacity');
      searchParams.delete('pub_batterycapacity');
    }
    searchParams.delete(key);
    history.push({
      search: searchParams.toString(),
    });
    window.location.reload();
  };

  const resetAll = e => {
    context.handleResetAll(e);
    window.location.reload();
  };

  return (
    <>
      {location.search && (
        <div className={css.modal_filters}>
          {Object.entries(filters).map(([key, value]) => {
            const name = value.configName;
            const currConfig = config.find(el => el.saveConfig.label === name);

            const toSpanishLang = () => {
              const val = value.value;
              if (val.includes(',')) {
                return val
                  .split(',')
                  .map(name => currConfig.enumOptions.find(el => el.option === name).label)
                  .join(',');
              } else {
                return currConfig.enumOptions.find(el => el.option === val).label;
              }
            };

            const newValue = value.value
              ? currConfig
                ? toSpanishLang()
                : value.value
              : value.value;

            if (newValue) {
              return (
                <div className={css.filterSign} key={key}>
                  {value.label}: {newValue}
                  <svg
                    onClick={() => removeFilter(key)}
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.00011 4.82178L10.1251 0.696777L11.3034 1.87511L7.17844 6.00011L11.3034 10.1251L10.1251 11.3034L6.00011 7.17844L1.87511 11.3034L0.696777 10.1251L4.82178 6.00011L0.696777 1.87511L1.87511 0.696777L6.00011 4.82178Z"
                      fill="#7C7C83"
                    />
                  </svg>
                </div>
              );
            }
            return null;
          })}
          <ResetBtn resetFilters={resetAll} />
        </div>
      )}
    </>
  );
};

export default ModalFilters;
